var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceAnalyticsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7580_10234)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3728 7.66542C16.1336 7.56929 15.8664 7.56929 15.6272 7.66542L11.3772 9.37301C10.9983 9.52525 10.75 9.89257 10.75 10.3009V14.875C10.75 17.7748 13.1002 20.125 16 20.125C18.8998 20.125 21.25 17.7748 21.25 14.875V10.3009C21.25 9.89257 21.0017 9.52525 20.6228 9.37301L16.3728 7.66542ZM20.2656 14.875C20.2656 17.2307 18.3557 19.1406 16 19.1406C13.6443 19.1406 11.7344 17.2307 11.7344 14.875V11.0177C11.7344 10.6202 11.9698 10.2604 12.3341 10.1013L15.5997 8.67485C15.8549 8.56337 16.1451 8.56337 16.4003 8.67485L19.6659 10.1013C20.0302 10.2604 20.2656 10.6202 20.2656 11.0177V14.875Z",
    fill: "#457AEF",
    stroke: "#457AEF",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1725 13.4958C14.1269 13.4499 14.0727 13.4136 14.013 13.3887C13.9533 13.3639 13.8892 13.3512 13.8246 13.3512C13.7599 13.3512 13.6959 13.3639 13.6362 13.3887C13.5765 13.4136 13.5222 13.4499 13.4766 13.4958C13.4308 13.5414 13.3944 13.5956 13.3696 13.6553C13.3448 13.715 13.332 13.779 13.332 13.8437C13.332 13.9084 13.3448 13.9724 13.3696 14.0321C13.3944 14.0918 13.4308 14.146 13.4766 14.1917L15.2458 15.9608L15.2745 15.9895C15.3176 16.0327 15.3689 16.067 15.4253 16.0904C15.4817 16.1138 15.5422 16.1259 15.6033 16.1259C15.6644 16.1259 15.7248 16.1138 15.7813 16.0904C15.8377 16.067 15.8889 16.0327 15.9321 15.9895L18.9878 12.9338C19.031 12.8907 19.0653 12.8394 19.0887 12.783C19.1121 12.7266 19.1241 12.6661 19.1241 12.605C19.1241 12.5439 19.1121 12.4835 19.0887 12.427C19.0653 12.3706 19.031 12.3194 18.9878 12.2762L18.9495 12.2379C18.9063 12.1947 18.8551 12.1604 18.7986 12.137C18.7422 12.1136 18.6817 12.1016 18.6207 12.1016C18.5596 12.1016 18.4991 12.1136 18.4427 12.137C18.3863 12.1604 18.335 12.1947 18.2919 12.2379L15.6026 14.9258L14.1725 13.4958Z",
    fill: "#457AEF",
    stroke: "#457AEF",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7580_10234",
    x: 0,
    y: 0,
    width: 31,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.772549 0 0 0 0 0.839216 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7580_10234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7580_10234",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAnalyticsIcon);
export default __webpack_public_path__ + "static/media/device_analytics_icon.c91de7aef91bdbab16576d9e9d927c5e.svg";
export { ForwardRef as ReactComponent };